import { BaseApi } from '@/modules/core/base.api';
import { TechnicalMessage } from './technical-message';
import * as API from '@shared/common/api';
import { PaginationResult } from '@shared/common/types';

class TechnicalMessageApi extends BaseApi {
    public apiPath = 'technical-message';

    public async getCount(): Promise<API.GetTechnicalMessageCount> {
        const response = await this.api.get<API.GetTechnicalMessageCount>(this.baseUrlFor('count'));
        return response.data;
    }

    public async findAll(options: object & { page: number }): Promise<PaginationResult<TechnicalMessage>>;
    public async findAll(options?: object): Promise<TechnicalMessage[]>;
    public async findAll(options: any = {}): Promise<TechnicalMessage[] | PaginationResult<TechnicalMessage>> {
        const response = await this.api.get(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });

        if (response.data.items) {
            response.data.items = response.data.items.map((message: any) => new TechnicalMessage(message));
        }

        return response.data;
    }

    public getExportUrl(options?: any): string {
        return this.api.getUri({ url: this.baseUrlFor('export'), params: options ? { sort: options.sort, ...options.filters } : undefined });
    }
}

export const technicalMessageApi = new TechnicalMessageApi();
